
























































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  tabNo: number,
  base_sheet_id: string,
  baseSheet: any,
  imageItems: any[],
  currentPage: number,
  errors: any[],
  scale: number,
  rotates: number[],
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      tabNo: 2,
      base_sheet_id: "",
      baseSheet: {},
      imageItems: [],
      currentPage: 1,
      errors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
    });

    /******************************
     * 表示中の画像情報
     ******************************/

    const currentImageItem = computed(() => {
      return state.imageItems[state.currentPage - 1];
    });

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed(() => {
      let style: any = {};
      style["width"] = `${currentImageItem.value.baseWidth * state.scale}px`;
      style["height"] = `${currentImageItem.value.baseHeight * state.scale}px`;
      style["transform"] = `rotate(${currentImageItem.value.angle}deg)`;
      
      // 回転の中心軸設定
      let translateX = "0px";
      let translateY = "0px";
      if(currentImageItem.value.angle == 90){
        translateX = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 180){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseHeight * state.scale / 2}px`;
      }else if(currentImageItem.value.angle == 270){
        translateX = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
        translateY = `${currentImageItem.value.baseWidth * state.scale / 2}px`;
      }

      style["transform-origin"]  = `${translateX} ${translateY}`;
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed(() => {
      const style: any = {};
      if(currentImageItem.value.angle == 0 || currentImageItem.value.angle == 180){
        style["height"] = `${(currentImageItem.value.baseHeight * state.scale) + 30}px`;
      }else{
        style["height"] = `${(currentImageItem.value.baseWidth * state.scale) + 30}px`;
      }
      return style;
    });

    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.05;
    }

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    }

    /******************************
     * 左回転ボタン押下
     ******************************/
    
    const rotateLeft = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentImageItem.value.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = currentImageItem.value.angle - 90;
      }
      currentImageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 右回転ボタン押下
     ******************************/
    
    const rotateRight = async () => {
      var angle = 0;
      var rotateIdx = state.rotates.indexOf(currentImageItem.value.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = currentImageItem.value.angle + 90;
      }
      currentImageItem.value.angle = angle;

      await rotateSave(false, false);
    }

    /******************************
     * 回転確定ボタン押下
     ******************************/
    
    const rotateSave = async (isConfirmMsg = true, isResutMsg = true) => {
      
      if(currentImageItem.value.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`${state.currentPage}ページ目の回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/correct_image_upload/rotate/${state.base_sheet_id}`, {angle: currentImageItem.value.angle, page: state.currentPage}).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        currentImageItem.value.base64Image = response.data.base64_image;
        currentImageItem.value.baseWidth = response.data.image_size_hash.width;
        currentImageItem.value.baseHeight = response.data.image_size_hash.height;
        currentImageItem.value.angle = 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 答案アップロード
     ******************************/

    const upload = async (files: any) => {
      const extension = Common.getFileExtension(files[0].name);
      if(extension == "jpg"){
        await uploadJpg(files);
      }else if(extension == "zip"){
        await uploadZip(files);
      }else if(extension == "pdf"){
        await uploadPdf(files);
      }
    }

    /******************************
     * アップロード（jpgドラッグ）
     ******************************/

    const uploadJpg = async (files: any) => {

      if(files.length != state.baseSheet.page_count){
        state.errors.push("画像数と問題構造のページ数が異なります。")
        return;
      }

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const config = {
        headers: {'content-type': 'multipart/form-data'}
      }

      let fd = new FormData();

      for(let i = 0; i < state.baseSheet.page_count; i++){
        fd.append(`${i}`, files[i]);
      }

      await http.post(`/api/correct_image_upload/upload_jpg/${state.base_sheet_id}`, fd, config).then((response) => {
        alert("アップロードが完了しました。");
        initData(response);
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（Zipドラッグ）
     ******************************/
    
    const uploadZip = async (files: any) => {

      let fd = new FormData();
      fd.append('upload[file]', files[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/correct_image_upload/upload_zip/${state.base_sheet_id}`, fd).then(response => {
        alert("アップロードが完了しました。");
        initData(response);
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * アップロード（PDFドラッグ）
     ******************************/
    
    const uploadPdf = async (files: any) => {

      let fd = new FormData();
      fd.append('upload[file]', files[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/correct_image_upload/upload_pdf/${state.base_sheet_id}`, fd).then(response => {
        alert("アップロードが完了しました。");
        initData(response);
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 採点枠設定へボタン押下
     ******************************/
    
    const toPositionEdit = () => {
      context.root.$router.push(`/teacher_site/position_edit/${state.base_sheet_id}`).catch(err => {});
    }

    /******************************
     * 初期表示データ設定
     ******************************/

    const initData = (response: any) => {
      state.baseSheet = response.data.base_sheet;
      var imageItems = [];
      for(var i = 0; i < response.data.base64_images.length; i++){
        var imageItem = {
          base64Image: response.data.base64_images[i],
          baseWidth: response.data.image_size_hashes[i].width,
          baseHeight: response.data.image_size_hashes[i].height,
          angle: 0,
        }
        imageItems.push(imageItem);
      }
      state.imageItems = imageItems;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      // APIで登録済み試験情報・模範解答画像取得
      await http.get(`/api/correct_image_upload?base_sheet_id=${state.base_sheet_id}`).then(response => {
        initData(response);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      currentImageItem,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
      rotateLeft,
      rotateRight,
      rotateSave,
      upload,
      toPositionEdit,
    }
  }
})
